import React from "react";
import { PropertyTaxesTable } from "../../components";
import { PageStructure } from "../../pages";

const PropertyTaxes = () => {
  return (
    <PageStructure>
      <h2>Property Taxes Management</h2>
      <p>Manage tax information for all properties. You can search for properties and edit their tax low and high values.</p>
      <PropertyTaxesTable />
    </PageStructure>
  );
};

export default PropertyTaxes;
